import BlockReplacement from './base/block-replacement';
export default BlockReplacement.extend().reopenClass({
  replacement: {
    pattern: /(?:[\s\S])?^#{2,6}\s(.+)?$/m,
    replaceWith: 'Subheading',
    captureGroupMapping: ['text'],
    config: 'allowMarkdownHeadings'
  }
});